<template>
  <DashboardDetailLayout
    title="Duplicate Companies"
    subtitle="Backlog from the de-duper, resolution rates, and hotspots by campaign."
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-1 mb-4">
      <MetricCard
        title="In Campaigns"
        value="134"
        subtitle="Flagged, still active"
        valueTone="warn"
        borderTone="warn"
        :fakeData="true"
      />
      <MetricCard
        title="Resolved (30d)"
        value="412"
        valueTone="good"
        trend="+6% vs prior 30d"
        trendDirection="up"
        :fakeData="true"
      />
      <MetricCard
        title="Merged (30d)"
        value="289"
        subtitle="Autodetect + human-confirmed"
        :fakeData="true"
      />
      <MetricCard
        title="Avg Age of Open Dup"
        value="11 days"
        subtitle="Since first flagged"
        :fakeData="true"
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-4">
      <ChartPlaceholder
        title="Duplicate Backlog"
        subtitle="Daily count, last 30 days"
        :barCount="30"
        :seed="5"
        tall
      />
      <ChartPlaceholder
        title="Resolved by Week"
        subtitle="Last 12 weeks"
        :barCount="12"
        :seed="17"
        tall
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-4">
      <ChartPlaceholder
        title="Duplicates by Campaign"
        subtitle="Top 10 campaigns with most open duplicates"
        :barCount="10"
        :seed="23"
      />
      <ChartPlaceholder
        title="Detection Source Mix"
        subtitle="Name match vs URL match vs ZoomInfo ID"
        :barCount="3"
        :seed="29"
      />
    </div>

    <div class="rounded-md border-2 border-dashed border-gray-300 bg-neutral-50 shadow p-3 m-2">
      <div class="flex flex-row items-center space-x-2 mb-2">
        <div class="text-sm tracking-widest text-gray-700 font-poppins uppercase">
          Oldest Open Duplicates
        </div>
        <SampleBadge />
      </div>
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-gray-500 border-b">
            <th class="py-1">Primary</th>
            <th class="py-1">Duplicate</th>
            <th class="py-1">Campaign</th>
            <th class="py-1">Flagged</th>
            <th class="py-1">Match Score</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in sampleDuplicates" :key="row.id" class="border-b last:border-0">
            <td class="py-1">{{ row.primary }}</td>
            <td class="py-1">{{ row.duplicate }}</td>
            <td class="py-1">{{ row.campaign }}</td>
            <td class="py-1">{{ row.flagged }}</td>
            <td class="py-1">{{ row.score }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </DashboardDetailLayout>
</template>

<script setup>
import DashboardDetailLayout from '../DashboardDetailLayout.vue'
import MetricCard from '../MetricCard.vue'
import ChartPlaceholder from '../ChartPlaceholder.vue'
import SampleBadge from '../SampleBadge.vue'

const sampleDuplicates = [
  { id: 1, primary: 'Acme Aerospace',     duplicate: 'ACME Aerospace Inc.',      campaign: 'Tier-1 Northeast',   flagged: '2026-03-02', score: '0.97' },
  { id: 2, primary: 'Heliosys Corp',      duplicate: 'Helio Systems Corporation', campaign: 'Avionics 2026',      flagged: '2026-03-07', score: '0.92' },
  { id: 3, primary: 'Falcon Machining',   duplicate: 'Falcon Machining LLC',      campaign: 'Machining Q2',       flagged: '2026-03-12', score: '0.99' },
  { id: 4, primary: 'Aegis Composites',   duplicate: 'Aegis Composites, Inc.',    campaign: 'Composites West',    flagged: '2026-03-15', score: '0.96' },
  { id: 5, primary: 'Summit Propulsion',  duplicate: 'Summit Propulsion Group',   campaign: 'Propulsion Tier-2',  flagged: '2026-03-19', score: '0.91' },
]
</script>